module.exports = __webpack_public_path__ + "html/comparison_a1e72fa591122522769c82176ace0f5a.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/comparison.html
// module id = Zx9N
// module chunks = 151